import _ from 'underscore';

export default function(divId) {
    var e = document.getElementById(divId);
    var text = (e && e.innerHTML) || '{}';
    return JSON.parse(_.unescape(text));
}

